import { render, staticRenderFns } from "./hotService.vue?vue&type=template&id=58f27142&scoped=true"
import script from "./hotService.vue?vue&type=script&lang=js"
export * from "./hotService.vue?vue&type=script&lang=js"
import style0 from "./hotService.vue?vue&type=style&index=0&id=58f27142&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f27142",
  null
  
)

export default component.exports